export function EmptyData() {
  return <div>Данные отсутствуют</div>;
}
